import { useEffect, useState } from "react"

import { ButtonDialog, DialogGeneral } from "#common/Dialog"
import Visibility from "@mui/icons-material/Visibility"
import VisibilityOff from "@mui/icons-material/VisibilityOff"
import IconButton from "@mui/material/IconButton"
import InputAdornment from "@mui/material/InputAdornment"
import TextField from "@mui/material/TextField"

//mui
import { api_rh_put } from "#api/API_RH"
import { Stack, Typography } from "@mui/material"
import { companyEmailEnd } from "../utils/functions"

export default function DialogEmailPassword(props) {
	const id = props?.colaborador?.id
	const colaborador = props?.colaborador?.nombre_colaborador
	const { setOpen, reloadNow } = props

	const [showPassword, setShowPassword] = useState(false)
	const [endEmail, setEndEmail] = useState("")
	const [dataSend, setDataSend] = useState({})

	const handleClickShowPassword = () => setShowPassword((show) => !show)
	const handleMouseDownPassword = (event) => {
		event.preventDefault()
	}

	useEffect(() => {
		const area_id = props.colaborador.area_id
		const sociedad_id = props.colaborador.sociedad_id
		const endMail = companyEmailEnd(area_id, sociedad_id)
		setEndEmail(endMail)
	}, [props.colaborador.area_id, props.colaborador.sociedad_id])

	async function send() {
		let data = { ...dataSend }
		data.email = data.email + endEmail

		const response = await api_rh_put(`colaboradores/${id}/email_institution`, data, {
			params: { new_email: true },
		})
		if (response) {
			reloadNow()
			setOpen(false)
		}
	}

	const buttonsOption = [
		<ButtonDialog key={"cancelar"} label="Cancelar" onClick={() => setOpen(false)} />,
		<ButtonDialog key={"enviar"} label="Enviar" onClick={() => send()} />,
	]
	return (
		<DialogGeneral
			{...props}
			title={
				<Typography variant="h6">
					Correo Empresa
					<br />
					{colaborador}
				</Typography>
			}
			buttons={buttonsOption}
		>
			<Stack
				spacing={2}
				style={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<TextField
					label="Correo electrónico"
					variant="outlined"
					fullWidth
					autoComplete="new-email"
					onChange={(event) => {
						setDataSend({ ...dataSend, email: event.target.value })
					}}
					InputProps={{
						endAdornment: endEmail,
					}}
				/>
				<TextField
					label="contraseña"
					variant="outlined"
					fullWidth
					autoComplete="new-password"
					onChange={(event) => {
						setDataSend({ ...dataSend, password: event.target.value })
					}}
					type={showPassword ? "text" : "password"}
					InputProps={{
						endAdornment: (
							<InputAdornment position="end">
								<IconButton
									aria-label="toggle password visibility"
									onClick={handleClickShowPassword}
									onMouseDown={handleMouseDownPassword}
									edge="end"
								>
									{showPassword ? <VisibilityOff /> : <Visibility />}
								</IconButton>
							</InputAdornment>
						),
					}}
				/>
			</Stack>
		</DialogGeneral>
	)
}
